/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/double-bed-1216077': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M20 3.5H4a3 3 0 00-3 3v13a1 1 0 001 1h4a1 1 0 00.83-.45l1.71-2.55h6.92l1.71 2.55a1 1 0 00.83.45h4a1 1 0 001-1v-13a3 3 0 00-3-3zm1 15h-2.46L16.83 16a1 1 0 00-.83-.5H8a1 1 0 00-.83.45L5.46 18.5H3v-5h18zm-14-7v-1a1 1 0 011-1h2a1 1 0 011 1v1zm6 0v-1a1 1 0 011-1h2a1 1 0 011 1v1zm8 0h-2v-1a3 3 0 00-3-3h-2a3 3 0 00-2 .78 3 3 0 00-2-.78H8a3 3 0 00-3 3v1H3v-5a1 1 0 011-1h16a1 1 0 011 1z"/>'
  }
})
